var _defaultValues;
import { AGB, PRIVACY } from "./field-names";
export var defaultValues = (_defaultValues = {}, _defaultValues[AGB] = false, _defaultValues[PRIVACY] = false, _defaultValues);
